'use strict';

var jsxRuntime = require('@emotion/react/jsx-runtime');
var react = require('@emotion/react');
var index = require('../../../aviary-core/dist/cjs/index.cjs');

/**
 * SVG Illustration of pregnancy
 */ const Pregnancy = ({ assetColor = index.ASSET_COLORS.grey, size = index.ILLUSTRATION_DIMENSIONS.medium, ...rest })=>{
    const theme = react.useTheme();
    return /*#__PURE__*/ jsxRuntime.jsxs("svg", {
        width: size,
        height: size,
        viewBox: "0 0 104 104",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...rest,
        children: [
            /*#__PURE__*/ jsxRuntime.jsx("circle", {
                cx: "52",
                cy: "52",
                r: "52",
                fill: theme.ds5.asset[assetColor].background
            }),
            /*#__PURE__*/ jsxRuntime.jsxs("g", {
                clipPath: "url(#clip0_3477_3591)",
                children: [
                    /*#__PURE__*/ jsxRuntime.jsx("ellipse", {
                        cx: "52.8343",
                        cy: "51.5608",
                        rx: "33.678",
                        ry: "33.678",
                        fill: theme.ds5.asset[assetColor]["500"]
                    }),
                    /*#__PURE__*/ jsxRuntime.jsx("path", {
                        d: "M81.7763 34.5987C82.0137 37.4351 81.7585 40.1293 80.7312 42.1484C79.4067 44.7522 76.9241 45.962 73.7372 45.5582C70.4485 45.1414 68.4327 45.2513 67.3925 45.9071C66.559 46.4336 66.1778 47.4189 65.522 49.2619C65.0148 50.6898 64.3816 52.4682 63.217 54.4501C60.9767 58.2638 57.5394 59.6125 54.4947 59.8467C56.3409 60.2634 58.6345 60.1891 60.8959 59.1683C65.4283 57.1234 67.9061 64.5535 69.3388 65.7359C70.7716 66.9167 70.5971 65.4694 73.0911 65.9847C75.585 66.4983 71.0849 71.6413 68.3713 70.0519C65.6593 68.4625 64.6788 65.4597 62.3044 65.8199C59.93 66.1801 61.2658 68.2702 58.0951 72.4457C54.9243 76.6211 41.7955 78.3753 37.2922 67.2074C33.3364 57.3947 40.9831 51.709 38.5634 48.0731C37.6734 46.7357 33.7096 43.7846 34.1796 39.3071C34.7078 34.2756 38.4196 26.5612 48.1806 27.7468C57.9432 28.9324 59.1482 36.2753 57.9206 40.9402C57.5426 42.3761 56.8142 42.914 56.6316 43.9284C58.3131 50.5509 52.8439 49.1973 50.5211 50.433C48.0772 51.7333 49.8944 53.0109 52.3399 53.4244C54.7854 53.838 51.7729 52.1468 54.128 50.8627C56.0453 49.8176 57.4667 54.1335 56.9143 56.2382C58.2647 55.6777 59.5908 54.6698 60.6165 52.9237C61.6357 51.1873 62.1913 49.6286 62.6808 48.2524C64.036 44.4404 65.1989 41.1291 71.2012 41.0823C71.2012 41.0823 74.4382 40.9854 75.4606 38.7709C76.2166 37.133 75.199 29.3879 72.2737 24.085C66.5315 19.8853 59.4519 17.4043 51.7907 17.4043C32.6064 17.4043 17.0547 32.956 17.0547 52.1403C17.0547 71.3247 32.6064 86.8764 51.7907 86.8764C70.9751 86.8764 86.5267 71.3247 86.5267 52.1403C86.5267 45.7407 84.7936 39.7465 81.7763 34.5971V34.5987Z",
                        fill: theme.ds5.asset[assetColor]["100"]
                    })
                ]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("defs", {
                children: /*#__PURE__*/ jsxRuntime.jsx("clipPath", {
                    id: "clip0_3477_3591",
                    children: /*#__PURE__*/ jsxRuntime.jsx("rect", {
                        width: "69.4737",
                        height: "69.4737",
                        fill: "white",
                        transform: "translate(17.0547 17.4043)"
                    })
                })
            })
        ]
    });
};

exports.Pregnancy = Pregnancy;
//# sourceMappingURL=Pregnancy.cjs.map
